// ResultsContext.js
import { createContext } from 'react';

const ResultsContext = createContext({});

export default ResultsContext;
